import { agGridFilterTypeMapDto, filterCondition, filterDateCondition } from '@shared/utils/constants';
import { AgGridFilterType, AgGridFilterTypeDto } from '@shared/utils/enums';
import { AgGridBaseFilterModel, AgGridDateFilterModel, AgGridDefaultFilterModel, BaseFilterDto } from '@shared/utils/interfaces';

import { normalizeDate } from '../normalize-date/normalize-date.helper';

const skipEmptyAgGridFilter = ({ filter }: AgGridDefaultFilterModel<unknown>): boolean => {
  if (Array.isArray(filter)) {
    return filter.length > 0 && !(filter.length === 1 && filter[0] === '');
  }

  return filter !== '' && filter !== null && filter !== undefined;
};

export const buildFilters = (filters: Record<string, AgGridBaseFilterModel>): BaseFilterDto[] => {
  return Object.entries(filters || {})
    .filter(([, filterObj]) => {
      if (filterObj.filterType !== AgGridFilterType.Date) {
        return skipEmptyAgGridFilter(filterObj as AgGridDefaultFilterModel<unknown>);
      }

      return true;
    })
    .map(([field, filterObj]) => {
      const baseFilters: BaseFilterDto = {
        field,
        filterType: agGridFilterTypeMapDto[filterObj.filterType] as AgGridFilterTypeDto,
      };

      let resultFilters: BaseFilterDto = { ...baseFilters };

      switch (filterObj!.filterType) {
        case AgGridFilterType.Date: {
          const dateFo = filterObj as AgGridDateFilterModel;
          resultFilters = {
            ...resultFilters,
            condition: filterDateCondition[filterObj.type!] || filterObj.type!.toUpperCase(),
            dateFrom: normalizeDate(dateFo.dateFrom),
            dateTo: normalizeDate(dateFo.dateTo, { endOfDay: true }),
          };
          break;
        }
        case AgGridFilterType.Dropdown: {
          resultFilters = {
            ...resultFilters,
            filter: (filterObj as AgGridDefaultFilterModel<string | number>).filter ?? null,
          };
          break;
        }

        case AgGridFilterType.Text: {
          const filterValue = (filterObj as AgGridDefaultFilterModel<string>).filter?.trim() ?? null;

          if (!filterValue) {
            return null;
          }

          resultFilters = {
            ...resultFilters,
            condition: filterCondition[filterObj.type!] || filterObj.type!.toUpperCase(),
            filter: (filterObj as AgGridDefaultFilterModel<string>).filter?.trim() ?? null,
          };
          break;
        }

        default: {
          resultFilters = {
            ...resultFilters,
            condition: filterCondition[filterObj.type!] || filterObj.type!.toUpperCase(),
            filter: (filterObj as AgGridDefaultFilterModel<string | number>).filter ?? null,
          };
          break;
        }
      }

      return resultFilters;
    })
    .filter((dto) => dto !== null);
};
